import { Feature } from "ol";
import { config } from "./config";
// import { Document } from "flexsearch";
/**
 * filter features by text
 * @param features array of features to filter
 * @param searchText text to apply for filtering
 * @returns an array of filtered features
 */

// const options = config.search.options;
// let searchFeatures: Feature[];
// let index = new Document(options);

export const filterByText = (features: Feature[], searchText: string): Feature[] => {
    const fields = config.search.searchFields || config.search.fieldsLV;
    if (!features || !features.length || !fields || !fields.length) {
        return [];
    }

    const result = features.filter((feature) => {
        let includes = false;
        for (let i = 0; i < fields.length; i++) {
            const value = feature.get(fields[i]);
            if (value && value.toLowerCase().includes(searchText.toLowerCase())) {
                includes = true;
                break;
            }
        }
        return includes;
    });

    // prioritize Mammadaba features
    if (result.length) {
        const mammadabaFeatures = [];
        const otherFeatures = [];
        for (const item of result) {
            if (item.get("PLACESUBTYPE") === 7) {
                mammadabaFeatures.push(item);
            } else {
                otherFeatures.push(item);
            }
        }
        return mammadabaFeatures.concat(otherFeatures);
    }
    return [];
};

// export const filterByTextFLEXSEARCH = (features: Feature[], searchText: string): Feature[] => {
//     if (!features || !features.length) {
//         return [];
//     }
//     if (features !== searchFeatures) {
//         setSearchIndex(features);
//     }

//     // perform search. Returns array, containing OBJECTID's
//     const matchIds = index.search(searchText);
//     // get features from matched OBJECTID's array
//     const mergedMatches = [];
//     if (matchIds.length) {
//         matchIds.forEach((element) => {
//             mergedMatches.push(...element.result);
//         });
//     }
//     const result = mergedMatches.length ? searchFeatures.filter((f) => mergedMatches.includes(f.get("OBJECTID"))) : [];

//     // prioritize Mammadaba features
//     if (result.length) {
//         const mammadabaFeatures = [];
//         const otherFeatures = [];
//         for (const item of result) {
//             if (item.get("PLACESUBTYPE") === 7) {
//                 mammadabaFeatures.push(item);
//             } else {
//                 otherFeatures.push(item);
//             }
//         }
//         return mammadabaFeatures.concat(otherFeatures);
//     }
//     return [];
// };

// const setSearchIndex = (features: Feature[]): void => {
//     searchFeatures = features;
//     index = new Document(options);
//     for (let y = 0, feature; y < features.length; y++) {
//         feature = features[y];
//         index.add({
//             id: feature.get("OBJECTID"),
//             feature: feature
//         });
//     }
// };
